module.exports = __webpack_public_path__ + "static/img/48.6b75ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Office365Deployment/48.png
// module id = q3eV
// module chunks = 1